// extracted by mini-css-extract-plugin
export default {"brandPromo":"qG-z","carousel":"rG-z"};